import { useAuthorizationViewModel } from '@viewModels/AuthorizationViewModel/AuthorizationViewModel';

export default async function ApiRequest(
    resource: RequestInfo,
    requestOptions?: RequestInit,
    isNeedAuth: boolean = true
): Promise<Response> {
    try {
        const options: RequestInit = requestOptions
            ? { ...requestOptions }
            : {};

        if (isNeedAuth) {
            const { getToken } = useAuthorizationViewModel.getState();
            const token = await getToken();
            if (token) {
                try {
                    options.headers = {
                        ...(options.headers || {}),
                        Authorization: `Bearer ${token}`,
                    };
                } catch (err) {
                    console.error('Error parsing auth token:', err);
                }
            }
        }

        const response = await fetch(resource, options);

        if (response.status === 401) {
            window.dispatchEvent(new CustomEvent('unauthorized'));
        }

        if (response.status === 502) {
            window.location.href = '/error';
        }

        if (!response.ok) {
            console.warn(
                'ApiRequest failed with status:',
                response.status,
                response.statusText
            );
        }

        return response;
    } catch (error) {
        console.error('ApiRequest error:', error);
        const errorMessage =
            error instanceof Error ? error.message : 'Unknown error';
        return new Response(JSON.stringify({ error: errorMessage }), {
            status: 500,
            headers: { 'Content-Type': 'application/json' },
        });
    }
}
